







import React, { useState, useMemo } from "react";
import { Box, Grid, Typography, IconButton, InputBase } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import SettingCard from "../../../components/Cards/SettingCard";
import card1 from "../../../assets/Settings/card1.svg";
import card2 from "../../../assets/Settings/card2.svg";
import card3 from "../../../assets/Settings/card3.svg";
import card4 from "../../../assets/Settings/card4.svg";
import card5 from "../../../assets/Settings/card1.svg"; // Privacy - reusing card1 for now
import card6 from "../../../assets/Settings/card2.svg"; // Company - reusing card2 for now
import AccountSetting from "./AccountSetting";
import GeneralSetting from "./GerneralSetting";
import NotificationsSetting from "./LogoutDeleteSettings";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RequestPayoutDrawer from "../Wallet/MyWallet/RequestDrawer";
import LogoutModal from "./Logout";
import { logout } from "../../../Redux/Slices/AuthSlice"; 
import { useDispatch, useSelector } from "react-redux";

const Settings = () => {
  const { t } = useTranslation("");
  const navigate = useNavigate();
  const [activeScreen, setActiveScreen] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
const [logoutLoading, setLogoutLoading] = useState(false);
  const cardData = useMemo(() => {
    const cards = t("settings_screen.cards", { returnObjects: true });
    return [
      {
        icon: card1,
        title: cards[0]?.title,
        description: cards[0]?.description,
       onClick: () => navigate("/settings/account"),
      },
      // {
      //   icon: card2,
      //   title: cards[1]?.title,
      //   description: cards[1]?.description,
      //   onClick: () => navigate("/settings/general"),
      // },
     
        {
        icon: card3,
        title: cards[4]?.title,
        description: cards[4]?.description,
        // screen: () => navigate("/my-wallet", { state: { openDrawer: true } }), /
         onClick: () => setDrawerOpen(true),
      },
//        {
//   icon: card3,
//   title: cards[2]?.title,
//   description: cards[2]?.description,
//   onClick: () => setLogoutModalOpen(true),   // 🔥 OPEN LOGOUT MODAL
// },
   
    ];
  }, [t]);

  return (
    <>
      <Box sx={{ px: 1, mt: 1 }}>
        {!activeScreen ? (
          <>
            <Box
              sx={{
                backgroundColor: "white",
                px: 2,
                py: 2,
                border: "1px solid #091E4224",
                borderRadius: "8px",
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 600,
                  fontSize: "16px",
                  color: "#003149",
                  textAlign: "left",
                }}
              >
                {t("settings_screen.title")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  pt: 1,
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("settings_screen.subtitle")}
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 2, // Adjust spacing between cards
                px: { xs: 1, sm: 2, lg: 10 },
                mt: 3,
              }}
            >
              {cardData.map((card, index) => (
                <Box
                  key={index}
                  sx={{
                    width: {
                      xs: "100%", // 1 card per row on mobile
                      sm: "calc(50% - px)", // 2 cards per row on small screens
 md: "calc(50% - 8px)",                    },
                  }}
                >
                  <Box
                    // onClick={() => setActiveScreen(card.screen)}
                      onClick={() => {
    if (card.onClick) card.onClick();
    else setActiveScreen(card.screen);
  }}
                    sx={{ cursor: "pointer" }}
                  >
                    <SettingCard {...card} />
                  </Box>
                </Box>
              ))}
            </Box>
          </>
        ) : (
          <Box>{activeScreen}</Box>
        )}
      </Box>
      <RequestPayoutDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <LogoutModal
  open={logoutModalOpen}
  loading={logoutLoading}
  onClose={() => setLogoutModalOpen(false)}
  onConfirm={async () => {
    try {
      setLogoutLoading(true);
      await dispatch(logout());   // If you are using redux logout
      navigate("/");
    } finally {
      setLogoutLoading(false);
      setLogoutModalOpen(false);
    }
  }}
/>

    </>
  );
};
export default Settings;

